/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import { IAccountingTransaction } from 'app/shared/model/accounting-transaction.model';
import { IAccountingBankAccount } from 'app/shared/model/accounting-bank-account.model';
import { IClinicalDictionary } from 'app/shared/model/clinical-dictionary.model';
import { AddedByType } from 'app/shared/model/enumerations/added-by-type.model';

export interface IAccountingCollectionLedger {
  id?: string;
  ledgerNo?: string;
  amount?: number;
  remarks?: number | null;
  pendingAmount?: number | null;
  collectedById?: string | null;
  collectedByType?: keyof typeof AddedByType | null;
  depositedById?: string | null;
  depositedByType?: keyof typeof AddedByType | null;
  closed?: boolean | null;
  entityId?: string | null;
  active?: boolean;
  cursor?: number;
  lastUpdated?: number;
  microSec?: number;
  timestampEntry?: number;
  expense?: IAccountingTransaction | null;
  income?: IAccountingTransaction | null;
  account?: IAccountingBankAccount | null;
  entityType?: IClinicalDictionary | null;
  accountingTransactions?: IAccountingTransaction[] | null;
}

export const defaultValue: Readonly<IAccountingCollectionLedger> = {
  closed: false,
  active: false,
};
